import store from '../../stores'
import * as fromScenes from '../../stores/ducks/scenes'
import { getSavedSceneId } from '../../stores/ducks/scenes/selectors'
import { SavedScene } from '../../stores/ducks/scenes/SavedScene'

interface SavedSceneResponse {
  id: string
  title: string
  updatedBy: string
  updatedAt: string
  updatedByName: string
  thumbnail: { key?: string } | null
}

function convertResponse (doc: SavedSceneResponse) : SavedScene {
  return {
    id: doc.id,
    title: doc.title || 'Untitled',
    thumbnail: doc.thumbnail?.key ? `/api/storage/get/${doc.thumbnail.key}.jpg` : null,
    updatedAt: doc.updatedAt || new Date().toISOString(),
    updatedBy: doc.updatedBy || 'Unknown user',
    updatedByName: doc.updatedByName,
  }
}

export default function handleSavedScenes (msg: { doc: SavedSceneResponse, status: 'created' | 'deleted' | 'renamed' | 'updated' }) {
  const { doc, status } = msg

  if (!doc.id) return

  const state = store.getState()
  const savedSceneId = getSavedSceneId(state)

  switch (status) {
    case 'created': {
      const newScene = convertResponse(doc)
      store.dispatch(fromScenes.mergeSceneIntoList(newScene))
      break
    }

    case 'deleted': {
      if (doc.id === savedSceneId) {
        store.dispatch(fromScenes.setPendingExternalDelete({ id: doc.id }))
      } else {
        store.dispatch(fromScenes.removeSceneFromList(doc.id))
      }
      break
    }

    case 'renamed': {
      const renamedScene = convertResponse(doc)
      if (renamedScene.id === savedSceneId) {
        store.dispatch(fromScenes.setPendingExternalRename(renamedScene))
      } else {
        store.dispatch(fromScenes.mergeSceneIntoList(renamedScene))
      }
      break
    }

    case 'updated': {
      const updatedScene = convertResponse(doc)
      if (updatedScene.id === savedSceneId) {
        store.dispatch(fromScenes.setPendingExternalUpdate(updatedScene))
      } else {
        store.dispatch(fromScenes.mergeSceneIntoList(updatedScene))
      }
      break
    }

    default:
      break
  }
}
